import { render, staticRenderFns } from "./PhotoReportList.vue?vue&type=template&id=513f2dbb&"
import script from "./PhotoReportList.vue?vue&type=script&lang=js&"
export * from "./PhotoReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports